// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"sr-only--19d91","srOnly":"sr-only--19d91"};